export default __webpack_public_path__ + "static/media/english-to-latvian-screenshot-04.6d0c07a9.png";